module.exports = __webpack_public_path__ + "static/media/toolbox.6dd4b1b9.svg";